import { useMemo } from "react";

const I18N_STUB = {
  language: "tr",
  changeLanguage: () => {},
};

const PHRASE_MAP = {
  loading: "Yukleniyor",
  save: "Kaydet",
  cancel: "Iptal",
  next: "Ileri",
  prev: "Geri",
  name: "Ad",
  email: "E-posta",
  role: "Rol",
  actions: "Islemler",
  status: "Durum",
  package: "Paket",
  business: "Isletme",
  user: "Kullanici",
  all: "Tum",
  select: "Sec",
  standard: "Standart",
  premium: "Premium",
  search_name_placeholder: "Isim ara",
  search_business_placeholder: "Isletme ara",
  no_records: "Kayit bulunamadi",
  error_generic: "Bir hata olustu",
  total_records: "Toplam kayit",
  created_at: "Olusturma tarihi",
  pricing_date: "Fiyatlandirma tarihi",
  demo_start: "Demo baslangic",
  demo_end: "Demo bitis",
  status_active: "Aktif",
  status_passive: "Pasif",
};

const toTitle = (value) =>
  value
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

const normalizeKey = (key) => String(key || "").trim().toLowerCase();

const translateKeyToText = (key) => {
  const normalized = normalizeKey(key);
  if (!normalized) return "";

  const leaf = normalized.split(".").pop() || normalized;
  if (PHRASE_MAP[leaf]) {
    return PHRASE_MAP[leaf];
  }

  return toTitle(leaf.replace(/[_-]+/g, " "));
};

const applyNamedVars = (text, options) => {
  if (!options) return text;

  return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => {
    const value = options[token];
    return value == null ? "" : String(value);
  });
};

const translate = (key, options) => {
  if (options && typeof options.defaultValue === "string" && options.defaultValue.trim()) {
    return options.defaultValue;
  }

  const base = translateKeyToText(key);

  if (normalizeKey(key).endsWith("total_records") && options && options.count != null) {
    return `${base}: ${options.count}`;
  }

  return applyNamedVars(base, options);
};

export const useTranslation = () => {
  return useMemo(
    () => ({
      t: translate,
      i18n: I18N_STUB,
    }),
    []
  );
};
